import { getOfferBlockMappings } from 'app/features/offer/blocks/block-mappings'
import { BlockRenderer, BlockRendererProps } from 'app/features/shared/blocks'
import { getBrandBlockMappings } from './block-mappings'

export const BrandBlockRenderer = (props: BlockRendererProps) => {
  return <BlockRenderer {...props} additionalComponents={{
    ...getBrandBlockMappings(),
    ...getOfferBlockMappings()
  }} />
}
